export default "__VITE_ASSET__25f39c31__"